import React from 'react';
import { shape, bool, instanceOf, func, string } from 'prop-types';
import Checkbox from '@material-ui/core/Checkbox';
import CATableHeaderButton from './CATableHeaderButton';
import {
  CA_CONTRACT_NAME,
  CA_LAST_MODIFIED,
  CA_STATUS,
  CA_CONTRACT_ACCOUNT,
  CA_CONTRACT_START,
  CA_CONTRACT_END,
  CA_PARENT_ACCOUNT,
} from '../../constants';
import { _getCheckedDefination } from '../../util/CommonUtils';
import IconCheckBoxEmpty from '../../components/autocode/ACShared/IconCheckBoxEmpty';
import IconCheckBoxCheck from '../../components/autocode/ACShared/IconCheckBoxCheck';

const CATableHeader = ({
  definition,
  updateQueryParams,
  toggleCheckboxState,
  isCheckedFlag = false,
  unableCheckbox = false,
}) => {
  const sortColumn = definition.query.sortColumn;
  let sortOrder = definition.query.sortOrder;
  const onClick = (label, newSortBy) => {
    if (sortColumn === newSortBy) {
      sortOrder = sortOrder === 'asc' ? 'desc' : 'asc';
    }
    updateQueryParams(
      {
        sortColumn: newSortBy,
        sortOrder,
      },
      'sort'
    );
  };
  let isDisabled = true;
  const activeDefination = _getCheckedDefination(definition.data, 'isActive');
  if (definition.data.length > 0) {
    isDisabled = false;
  }
  let isIndeterminate = false;
  let isChecked = false;
  if (activeDefination.length > 0) {
    isIndeterminate = true;
    isChecked = true;
    if (activeDefination.length === definition.data.length) {
      isIndeterminate = false;
    }
  }
  const _handleOnChange = () => {
    toggleCheckboxState(!isCheckedFlag);
  };
  return (
    <div className="ca--table__head">
      <div className="ca--table__row">
        {unableCheckbox && (
          <Checkbox
            className="header-checkbox"
            onChange={_handleOnChange}
            checked={isCheckedFlag}
            id="caHeader"
            color="primary"
            icon={<IconCheckBoxEmpty fill="#30435D" stroke="#DADADA" />}
            checkedIcon={
              <IconCheckBoxCheck fill="#DADADA" stroke="#DADADA" opacity="0" />
            }
            disabled={false}
          />
        )}

        <div className="ca--table__col ca-ct--col__column" data-test="caHeader">
          <CATableHeaderButton
            data-test="caHeaderClick"
            label={CA_CONTRACT_ACCOUNT}
            isDisabled={isDisabled}
            sortColumn="account_accountName"
            sortOrder={sortOrder}
            onClick={onClick}
            isActive={sortColumn === 'account_accountName'}
          />
        </div>
        <div className="ca--table__col ca-ct--col__column" data-test="caHeader">
          <CATableHeaderButton
            data-test="caHeaderClick"
            label={CA_PARENT_ACCOUNT}
            isDisabled={isDisabled}
            sortColumn="account_parentAccountName"
            sortOrder={sortOrder}
            onClick={onClick}
            isActive={sortColumn === 'account_parentAccountName'}
          />
        </div>
        <div className="ca--table__col ca-ct--col__column" data-test="caHeader">
          <CATableHeaderButton
            data-test="caHeaderClick"
            label={CA_CONTRACT_NAME}
            isDisabled={isDisabled}
            sortColumn="contractName"
            sortOrder={sortOrder}
            onClick={onClick}
            isActive={sortColumn === 'contractName'}
          />
        </div>
        <div className="ca--table__col ca-ct--col__column" data-test="caHeader">
          <CATableHeaderButton
            label={CA_LAST_MODIFIED}
            isDisabled={isDisabled}
            sortColumn="updTs"
            sortOrder={sortOrder}
            onClick={onClick}
            isActive={sortColumn === 'updTs'}
          />
        </div>

        <div className="ca--table__col ca-ct--col__column" data-test="caHeader">
          <CATableHeaderButton
            label={CA_STATUS}
            isDisabled={isDisabled}
            sortColumn="status"
            sortOrder={sortOrder}
            onClick={onClick}
            isActive={sortColumn === 'status'}
          />
        </div>

        <div className="ca--table__col ca-ct--col__column" data-test="caHeader">
          <CATableHeaderButton
            label={CA_CONTRACT_START}
            isDisabled={isDisabled}
            sortColumn="contractStart"
            sortOrder={sortOrder}
            onClick={onClick}
            isActive={sortColumn === 'contractStart'}
          />
        </div>

        <div className="ca--table__col ca-ct--col__column" data-test="caHeader">
          <CATableHeaderButton
            label={CA_CONTRACT_END}
            isDisabled={isDisabled}
            sortColumn="contractEnd"
            sortOrder={sortOrder}
            onClick={onClick}
            isActive={sortColumn === 'contractEnd'}
          />
        </div>
      </div>
    </div>
  );
};

CATableHeader.propTypes = {
  definition: shape({
    loading: bool,
    error: bool,
    data: instanceOf(Array),
    query: shape({
      sortBy: string,
      sortOrder: string,
    }),
  }),
  setSelectedTargets: func,
  updateQueryParams: func,
  toggleCheckboxState: func,
  isCheckedFlag: bool,
  unableCheckbox: bool,
};

CATableHeader.defaultProps = {
  definition: {
    loading: true,
    error: false,
    data: [],
    query: {
      sortBy: 'updts',
      sortOrder: 'desc',
    },
  },
};

export default CATableHeader;
